export default __webpack_public_path__ + "static/media/15.08559756.jpg";